import styles from '../Row/styles';

export default styles;
